import { SortOrder } from 'antd/es/table/interface'
import { Sorter } from '../../../components/Sorter/Sorter'
import { ColumnsType } from 'antd/es/table'
import { UserContractCategory } from '../../UserContractCategories/types'
import { ActionsCell } from '../../UserContractCategories/ActionsCell/ActionsCell'
import { Tooltip } from 'components/Tooltip/Tooltip'
import { BUTTON_TYPES, Button } from 'components/Button'
import { ReactComponent as Information } from 'assets/svg/Information.svg'
import { Checkbox } from 'components/Checkbox'

export type OnChangeVotingPanelMembershipProps = {
  ccId: string
  name: string
  value: boolean
}

export const columns = (
  canDelete: boolean,
  onDeleteCC: (id: string) => void,
  onChangeVotingPanelMembership?: (
    props: OnChangeVotingPanelMembershipProps
  ) => void,
  canViewVotingPanelMembership?: boolean,
  canUpdateVotingPanelMembership?: boolean
): ColumnsType<UserContractCategory> => {
  const columns: ColumnsType<UserContractCategory> = [
    {
      dataIndex: 'name',
      key: 'name',
      className: 'vertical-align-middle',
      title: ({ sortOrder, sortColumn }) => (
        <Sorter
          dataIndex="name"
          sortColumn={sortColumn}
          sortOrder={sortOrder as SortOrder}
        >
          Contract category
        </Sorter>
      ),
      sorter: true,
      showSorterTooltip: false
    }
  ]

  if (canViewVotingPanelMembership) {
    columns.push({
      dataIndex: 'is_voting_panel_member',
      key: 'is_voting_panel_member',
      className: 'vertical-align-middle',
      title: () => (
        <div className="row align-center gap-4">
          Voting panel member
          <Tooltip title="Indicates if the Hospital user is authorized to vote in this category.">
            <Button.Icon
              icon={<Information />}
              type={BUTTON_TYPES.GHOST}
              small
            />
          </Tooltip>
        </div>
      ),
      render: (checked, { uuid: ccId, name }) => (
        <Checkbox
          propsCheckbox={{
            disabled: !canUpdateVotingPanelMembership,
            checked,
            onChange: () =>
              onChangeVotingPanelMembership?.({
                ccId,
                name,
                value: !checked
              })
          }}
        />
      )
    })
  }

  if (canDelete) {
    columns.push({
      dataIndex: 'actions',
      key: 'actions',
      className: 'vertical-align-middle',
      title: '',
      width: 24,
      fixed: 'right',
      render: (_, cc) => (
        <ActionsCell
          cc={cc}
          onDeleteCC={onDeleteCC}
          isReview={false}
          canManageAssignment={false}
          canDelete
        />
      )
    })
  }

  return columns
}
